export const SourceProperty = Object.freeze({
  MESSAGES: 'messages',
  WORKBOOK_VIEW_ON_DEMAND: 'workbookViewOnDemand'
});
